export const renderNumber = (filters: any[]) => {
  const number = filters.filter((e) => e !== null).length;
  return number;
};

export const onlyNumbers = (value: string) => value.replace(/[^0-9.]+/g, '');
